import {
  SearchApiModel,
  useAxios,
  useDeleteNulls,
} from "@sttedra_ui/framework";

import WorkspacesApiResponseModel from "./workspaces.api-response-model.js";
import WorkspacesApiRequestModel from "./workspaces.api-request-model.js";

// #region Globals
const { base } = useAxios();
const timeout = 5000;
// #endregion

// #region Public functions
async function workspacesList(searchParams = {}) {
  try {
    const searchModel = new SearchApiModel(searchParams);

    useDeleteNulls(searchModel);

    const url = `/Workspace/list`;

    const { data: response } = await base.post(url, searchModel, {
      timeout,
    });

    const { data: originalData, pageSize, pageIndex, totalResults } = response;

    originalData.forEach((data) => {
      data.dateProperty = new Date("2024-04-09T11:41:16.0312417");
    });

    const data = originalData.map((u) => new WorkspacesApiResponseModel(u));

    return {
      data,
      pageSize,
      pageIndex,
      totalResults,
    };
  } catch (err) {
    localStorage.setItem("errorToastMessage", "Error al buscar los registros");

    return err;
  }
}

async function workspacesListAll(searchParams = {}) {
  try {
    const searchModel = new SearchApiModel(searchParams);

    useDeleteNulls(searchModel);

    const url = `/Workspace/listAll`;

    const response = await base.get(url, searchModel, {
      timeout,
    });

    const data = response.data.map((u) => new WorkspacesApiResponseModel(u));

    return data;
  } catch (err) {
    localStorage.setItem("errorToastMessage", "Error al buscar los registros");

    return err;
  }
}

async function workspacesCreate(params = {}) {
  try {
    const workspaceModel = new WorkspacesApiRequestModel(params);

    useDeleteNulls(workspaceModel);

    const url = `/Workspace/addWorkspace`;

    const response = await base.post(url, workspaceModel, {
      timeout,
    });

    return response;
  } catch (err) {
    return err;
  }
}

async function workspacesUpdate(guidWorkspace, params = {}) {
  try {
    const workspaceModel = new WorkspacesApiRequestModel(params);

    useDeleteNulls(workspaceModel);

    const url = `/Workspace/${guidWorkspace}/updateWorkspace`;

    const response = await base.put(url, workspaceModel, {
      timeout,
    });

    return response;
  } catch (err) {
    return err;
  }
}

async function workspacesDelete(guidWorkspace) {
  try {
    const url = `/Workspace/${guidWorkspace}/deleteWorkspace`;

    const response = await base.delete(url, {
      timeout,
    });

    return response;
  } catch (err) {
    return err;
  }
}
// #endregion

// #region Private functions
// #endregion

export {
  workspacesList,
  workspacesListAll,
  workspacesCreate,
  workspacesUpdate,
  workspacesDelete,
};
